@if (!isEmbedded()) {
  <app-theme-toggle class="legal-page__theme-toggle" />
}

<div class="legal-page" [class.legal-page--embedded]="isEmbedded()">

  <!-- ── En-tête ── -->
  <header class="legal-page__header">
    <!-- Hors application seulement : dans le layout, la sidebar porte déjà la
         marque et l'utilisateur n'a pas à « retourner à la connexion ». -->
    @if (!isEmbedded()) {
    <a routerLink="/sign-in" class="legal-page__back">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 5l-7 7 7 7"/></svg>
      Retour à la connexion
    </a>
    <div class="legal-page__brand">
      <svg class="legal-page__logo" viewBox="0 0 187 75" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M161.737 49.6V74.8H140.125V49.6H114.925V28.1625H140.125V2.96252H161.737V28.1625H186.762V49.6H161.737Z" />
        <path fill="currentColor" d="M98.7875 0C104.213 0 108.996 1.1375 113.138 3.4125C117.279 5.62917 120.517 9.07083 122.85 13.7375C125.242 18.4042 126.438 24.4125 126.438 31.7625V73.9375H100.275V35.7875C100.275 30.7708 99.5167 26.7167 98 23.625C96.4833 20.5333 93.4792 18.9875 88.9875 18.9875C86.3042 18.9875 83.9417 19.6875 81.9 21.0875C79.8583 22.4875 78.2833 24.4417 77.175 26.95C76.0667 29.4 75.5125 32.3458 75.5125 35.7875V73.9375H51.1V35.7875C51.1 30.7708 50.2542 26.7167 48.5625 23.625C46.9292 20.5333 44.0125 18.9875 39.8125 18.9875C37.1292 18.9875 34.7667 19.6875 32.725 21.0875C30.6833 22.4292 29.1083 24.3542 28 26.8625C26.95 29.3125 26.425 32.2875 26.425 35.7875V73.9375H0V2.1H26.425V12.3375C27.125 10.5292 28.6417 8.69167 30.975 6.825C33.3667 4.9 36.3125 3.29584 39.8125 2.0125C43.3125 0.670834 47.0167 0 50.925 0C55.1833 0 58.7417 0.641668 61.6 1.925C64.4583 3.15 66.7917 4.8125 68.6 6.9125C70.4667 9.0125 71.9542 11.2875 73.0625 13.7375C73.8792 11.6375 75.4833 9.5375 77.875 7.4375C80.325 5.27917 83.3583 3.5 86.975 2.1C90.65 0.7 94.5875 0 98.7875 0Z"/>
      </svg>
      <span class="legal-page__brand-name">Mokah+</span>
    </div>
    }
    <!-- Le corps du document répète son propre titre : l'afficher ici aussi
         créait un doublon dans l'application. La mention de version, elle,
         n'existe nulle part ailleurs — elle est reprise dans la carte. -->
    @if (!isEmbedded()) {
      <div class="legal-page__title-block">
        <h1 class="legal-page__title">{{ title() }}</h1>
        @if (displayedVersion(); as version) {
          <p class="legal-page__meta">
            Version {{ version.version }}
            @if (effectiveDate(); as date) {
              — en vigueur depuis le {{ date | date:'d MMMM y' }}
            }
          </p>
        }
      </div>
    }
  </header>

  <!-- ── Corps ── -->
  <div class="legal-page__body legal-page__body--single">
    <main class="legal-page__content">

      @if (isEmbedded() && displayedVersion(); as version) {
        <p class="legal-page__version-inline">
          Version {{ version.version }}
          @if (effectiveDate(); as date) {
            — en vigueur depuis le {{ date | date:'d MMMM y' }}
          }
        </p>
      }

      @if (isArchivedView()) {
        <div class="legal-banner legal-banner--archived">
          <span>
            Vous consultez une <strong>version archivée</strong> (v{{ archivedVersion()?.version }}).
            @if (replacedByVersion(); as next) {
              Elle a été remplacée le {{ (next.effective_at ?? next.published_at) | date:'d MMMM y' }} par la version {{ next.version }}.
            } @else {
              Consultez la version en vigueur pour le texte applicable.
            }
          </span>
          <button type="button" class="legal-banner__action" (click)="returnToCurrentVersion()">
            Revenir à la version en vigueur
          </button>
        </div>
      }

      @if (versionSwitchError()) {
        <div class="legal-banner legal-banner--error">
          Impossible de charger cette version. Merci de réessayer.
        </div>
      }

      @if (isOrganisationDocument()) {
        @if (showOrganisationSignAction()) {
          <div class="legal-sign-action" [class.legal-sign-action--required]="signatureIsRequired()">
            <div class="legal-sign-action__text">
              @if (signatureIsRequired()) {
                <p class="legal-sign-action__title">Signature requise</p>
                <p class="legal-sign-action__hint">
                  Une nouvelle version de ce document exige une re-signature. Merci de la relire et
                  de la signer en tant qu'administrateur pour rester en règle.
                </p>
              } @else {
                <p class="legal-sign-action__title">Signature en attente</p>
                <p class="legal-sign-action__hint">
                  Ce document n'a pas encore été signé par votre organisation. Vous pouvez le signer
                  en tant qu'administrateur.
                </p>
              }
            </div>

            <label class="legal-sign-action__checkbox">
              <input
                type="checkbox"
                [checked]="signAcknowledged()"
                [disabled]="signing()"
                (change)="toggleSignAcknowledged()"
              />
              <span>{{ signCheckboxLabel() }}</span>
            </label>

            <button
              type="button"
              class="legal-sign-action__button"
              [disabled]="signing() || !signAcknowledged()"
              (click)="signOnBehalfOfOrganisation()"
            >
              {{ signing() ? 'Signature en cours…' : signButtonLabel() }}
            </button>
          </div>
          @if (signError(); as errorMessage) {
            <div class="legal-banner legal-banner--error">{{ errorMessage }}</div>
          }
        } @else if (organisationAlreadySigned() && organisationConsent(); as consent) {
          <div class="legal-sign-confirmation">
            Signé au nom de <strong>{{ organisationLabel() }}</strong>
            le {{ consent.consented_at | date:'d MMMM y' }}
            @if (consent.signer_name ?? consent.signer_email; as signer) {
              par {{ signer }}
            }
            .
          </div>
        }
      }

      @if (displayedVersion(); as version) {
        <div class="legal-document__body" [innerHTML]="renderedContent()"></div>
      } @else if (showFallback()) {
        <div class="legal-fallback">
          <p>Ce document est temporairement indisponible.</p>
          <p>Merci de contacter <a href="mailto:contact@mokahplus.com">contact&#64;mokahplus.com</a> si le problème persiste.</p>
        </div>
      } @else {
        <div class="legal-loading">Chargement du document…</div>
      }


    </main>
  </div>

  <!-- ── Pied de page ── -->
  <footer class="legal-page__footer">
    @if (!isEmbedded()) {
      <a routerLink="/sign-in" class="legal-page__footer-link">← Retour à la connexion</a>
    }
    @for (link of siblingLinks(); track link.path) {
      <a [routerLink]="link.path" class="legal-page__footer-link">{{ link.label }}</a>
    }
    <p class="legal-page__copyright">© {{ currentYear }} MOKAHPLUS — Mokah+</p>
  </footer>

</div>
